import { action, makeObservable, observable } from 'mobx';
import { IEmployeeDataManager } from 'typings/dataManagers';
import { dataManagerFactory } from 'utils/MobxDataManager/singletons';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { Employee } from 'nomst/Stores/Decision/employee';

export class JobCollabEmployees {
    private readonly masterAccountId: string;
    private employeeDataManager: IEmployeeDataManager;
    private readonly configuration: Configuration;
    @observable employees: Employee[];
    @observable employeesFetched: boolean;
    @observable selectedEmployeeSourceId: string;
    @observable selectedEmployee: Nullable<Employee>;
    @observable employeeDetailsFetched: boolean;
    
    constructor(masterAccountId: string, configuration: Configuration) {
        makeObservable(this);
        this.masterAccountId = masterAccountId;
        this.configuration = configuration;
        this.employeeDataManager = dataManagerFactory.getEmployeeDataManager();
        this.employees = [];
        this.employeesFetched = false;
        this.selectedEmployee = null;
        this.selectedEmployeeSourceId = '';
        this.employeeDetailsFetched = false;
    }

    get shouldShowRange(): boolean {
        return this.configuration.payRangeConfiguration.showPayRange;
    }

    get shouldShowTcc(): boolean {
        return this.configuration.teamPageViews.tcc;
    }

    @action
    async getEmployeeList(): Promise<void> {
        if (!this.employees.length) {
            this.employees = await this.employeeDataManager.getEmployeeJobCollabList(this.masterAccountId);
            this.employeesFetched = true;
        }
    }

    @action
    async setSelectedEmployeeSourceId(employeeSourceId: string): Promise<void> {
        this.selectedEmployeeSourceId = employeeSourceId;
        return this.getEmployeeDetails();
    }

    @action
    async getEmployeeDetails(): Promise<void> {
        if (this.selectedEmployeeSourceId !== this.selectedEmployee?.employeeSourceId) {
            this.selectedEmployee = null;
        }

        if (this.selectedEmployeeSourceId) {
            this.employeeDetailsFetched = false;
            const employeeDto = await this.employeeDataManager.getEmployeeDetails(this.masterAccountId, this.selectedEmployeeSourceId);
            employeeDto ? this.selectedEmployee = new Employee(employeeDto, 2080, null, this.configuration, null, null)
                : this.selectedEmployee = null;
            await this.selectedEmployee?.getEmployeeInfo(this.masterAccountId);
            this.employeeDetailsFetched = true;
        }
    }

    // tslint:disable-next-line: no-unused-variables Must match signature of CurrencyFormatFunc
    formatCurrencyValue(
        value: number,
        currency: string,
        options: FormatOptions,
        callback: (result: string) => void): void {
        const result = this.configuration.format.formatCurrencyValue(
            currency,
            value,
            false);
        callback(result);
    }
}